<template>
<div class="slide slide02">
	<h3 class="title">
		퍼포먼스 마케팅 성과의 <br class="mo">극대화와 광고주 편의성을 위해 <br>통합 퍼포먼스 서비스를 원스탑으로 제공합니다
	</h3>
	<span class="text">
		기존의 퍼포먼스 마케팅은 SA, DA를 구분하고 영역에 따라 전문 대행사를 활용하면서 통합적인 관점에서의 <br>
		퍼포먼스 전략과 실행이 부재하였으나 GnM performance를 통해 일원화한 대행구조를 통해 <br>
		통합적인 관점에서 퍼포먼스 마케팅의 전략과 실행을 완성할 수 있습니다.
	</span>

	<div class="serviceBox" v-if="$device.windows">
		<div class="service">
			<span>Advertisers</span>
			<span class="arrow">
				One Stop Service
				<img src="@/assets/images/icoServiceArrow.png" alt="왼쪽 방향 화살표">
			</span>
			<span>
				GnM<br>
				Performance
			</span>
		</div>

		<div class="tableBox">
			<table class="table">
				<colgroup>
					<col width="144px">
					<col width="154px">
					<col width="462px">
				</colgroup>
				<thead>
					<th colspan="3">Integrated Performance Marketing Service</th>
				</thead>
				<tbody>
					<tr>
						<th>
							통합 퍼포먼스 <br> 플래닝
						</th>
						<td class="color03">
							검색마케팅 <br> 퍼포먼스 광고 <br> 퍼포먼스 소셜 마케팅 <br> 미디어 플랫폼 서비스
						</td>
						<td>
							네이버, 구글, 애플 검색 지면 광고 및 검색엔진최적화 <br> 광고주의 마케팅 성과 달성을 위한 데이터 기반의 퍼포먼스 DA <br> 페이스북, 인스타그램 등 소셜미디어 기반의 컨텐츠 제작 및 계정 운영 <br> 자체 미디어 플랫폼(동영상, 앱퍼포먼스, 인플루언서 플랫폼) 개발 및 서비스
						</td>
					</tr>
					<tr>
						<th></th>
						<td>
							크리에이티브
						</td>
						<td>
							애드테크
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
	<div class="serviceImg" v-else>
		<img src="@/assets/images/featureSlideMo01.png" alt="">
	</div>
	<div class="btnsWrap">
		<a herf="javascript:;" @click="fnSlickNext" class="slideNextBtn" v-if="!$device.windows">다음 페이지</a>
	</div>
</div>
</template>
<script>
export default {
	methods:{
		fnPopClose(){
			this.$emit('popClose' , event)
		},
		fnSlickNext(){
			this.$emit('slick_next' , event)
		}
	}
}
</script>